

























































































































import {auth, functions} from "@/scripts/firebase";
import {NoticeProps, UserRole} from "@/scripts/datatypes";
import { Component,Watch ,Mixins} from "vue-property-decorator";
import Notice from "@/components/Notice.vue";
import Common from '@/mixins/common'
import { ValidationObserver } from 'vee-validate'
//import { ValidationResult } from 'vee-validate/dist/types/types';

//eslint-disable-next-line
const jaconv = require("jaconv")

/**
 * 権限変更
 * 自分の権限以下のアカウントのみ作れる
 * 
 * メールアドレスが存在したときの処理
 * 
 */
/**
 * 招待メール再送ボタン追加
 */
/**
 * さしあたり画像はなし
 */

interface User {
	role?: string;
	accessLevel?: number;
	displayName?: string;
	lastName?: string;
	firstName?: string;
	lastNameYomigana?: string;
	firstNameYomigana?: string;
  email?: string;
  lang?: string;
  profileImage?: string;
  emailVerified?: boolean;
}

@Component({
  components: {
    Notice,
  }
})

export default class AddUser extends Mixins(Common) {
  isLoading = false
  notice: NoticeProps = {}
  disabledAddUser = true
  userMeta: User = {}

  userRolesAccessLevels: UserRole  = {}

  @Watch('userMeta',{deep: true})
  async changeUserMeta(newVal: User, oldVal: User){
    if(Object.keys(oldVal).length ==  0 ){
      return
    }

    if(newVal.lastNameYomigana){
      newVal.lastNameYomigana = jaconv.toHiragana(jaconv.toZenKana(newVal.lastNameYomigana))
      newVal.lastNameYomigana = (newVal.lastNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }

    if(newVal.firstNameYomigana){
      newVal.firstNameYomigana = jaconv.toHiragana(jaconv.toZenKana(newVal.firstNameYomigana))
      newVal.firstNameYomigana = (newVal.firstNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }

    this.disabledAddUser = false
  }

  mounted(){
    console.log('mounted');
  }

  get observer(){
    return this.$refs.addUserValidationObserver as InstanceType<typeof ValidationObserver>
  }

  get defaultUserMeta(){
    return {
      lang: this.$store.getters.lang,
      role: this.$defaultUserRole
    }
  }

  async created() {
    console.trace('created')
    this.userMeta = {...this.defaultUserMeta}

    const getUserRolesAccessLevels = functions.httpsCallable('getUserRolesAccessLevels');
    const userRolesAccessLevels = await getUserRolesAccessLevels({schoolId: this.$store.getters.schoolId})
    if(userRolesAccessLevels.data){
      this.userRolesAccessLevels = userRolesAccessLevels.data
    }
  }

  get languages(): string[]{
    if(this.$i18n.availableLocales){
      return this.$i18n.availableLocales
    }
    return [];
  }

  get roles(): string[]{
    const roles = Object.keys(this.userRolesAccessLevels)
    return roles
    /*
    return roles.sort((a,b) => {
      const uLa = this.userRolesAccessLevels[roles[a as any]]
      const uLb = this.userRolesAccessLevels[roles[b as any]]
      return uLa.accessLevel - uLb.accessLevel
    })
    */
  }

  async addUser(){
    try{
      this.notice = {
				isShow: false,
      }
			
			if(await this.observer.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        console.log(this.userMeta)

        const getUsers = functions.httpsCallable('getUsers');
        
        const userAuthData = await getUsers({identifiers: [{email: this.userMeta.email}], schoolId: this.$store.getters.schoolId})
        console.log(userAuthData.data)
        if(userAuthData.data && Object.keys(userAuthData.data).length === 1){
          this.observer.setErrors({
            email: this.$t('addUser.emailAlreadyMember') as string
          })
          this.$store.commit("setLoading",false);
          this.isLoading = false
          return
        }

        let userRecord
        let emailAlreadyExists = false
        try{
          const createUser = functions.httpsCallable('createUser');
          userRecord = await createUser({schoolId: this.$store.getters.schoolId, ...this.userMeta})
        }catch(error){
          const errorCode = this.$getErrorCode(error)
          if(errorCode === 'auth/email-already-exists'){
            emailAlreadyExists = true
            const addUser = functions.httpsCallable('addUser');
            userRecord = await addUser({schoolId: this.$store.getters.schoolId, ...this.userMeta})
          }
        }

        console.log(userRecord)

        // email is not required
        if(userRecord && userRecord.data.email){
          const sendMail = functions.httpsCallable('sendEmail');
          const data = {
            uid: userRecord.data.uid,
            schoolId: this.$store.getters.schoolId,
            actionType: 'passwordReset',
            template: 'welcomToMaritoMail'
          }

          if(emailAlreadyExists){//メール確認いらない
            data.actionType = 'sendEmail'
            data.template = 'welcomToSchoolMail'
          }

          try{
            const sentMail = await sendMail(data);

            if(sentMail.data){
              //message += '<br />メールを送信しました'
            }
          }catch(error){
            //
          }
        }

        this.notice = {
          message: this.$t('addUser.added') as string,
          isShow: true,
          type: {'is-success': true}
        }
        this.userMeta = {...this.defaultUserMeta}
        this.observer.reset()
      }
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('addUser.error') as string
      
			const errorMessage1 = this.$getErrorMessage(errorCode)

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disabledAddUser = true
      //this.observer.reset()
    }
  }

}
/*
 public async linkGoogleAuth(){
  const provider = new authObject.GoogleAuthProvider();
  const user = auth.currentUser;
  if(user == null){
    return;
  }
  
  try{
      await user.linkWithRedirect(provider);
  }catch(error) {
    console.log('linkGoogleAuth failed',error.code, error.message);
  }
 }

 */
